/** 左侧菜单排序 */

export default {

  /** 这些为系统菜单 */
  System: 110000,
  Permission: 110010,
  LocalExtension: 110050
}
